import { render, staticRenderFns } from "./CartDetailedFooter.vue?vue&type=template&id=4743dce0&scoped=true&"
import script from "./CartDetailedFooter.vue?vue&type=script&lang=ts&"
export * from "./CartDetailedFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CartDetailedFooter.vue?vue&type=style&index=0&id=4743dce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4743dce0",
  null
  
)

export default component.exports